import axios from 'axios';
import React, { useEffect, useState } from 'react';

const FirmHeaderImg = ({ firmId }) => {

    const imgUrl = process.env.REACT_APP_IMAGE_URL;
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const [firmUrl, setFirmUrl] = useState('');

    useEffect(() => {
        fetchData(firmId);
    }, [firmId]);

    const fetchData = async (id) => {
        try {
            const response = await axios.get(`${baseUrl}?apicall=getFirmHeaderImg&firmId=${id}`);
            const url = response?.data?.data?.firmImg;

            const update_url = url?.replace(/ /g, '%20');
            setFirmUrl(update_url);
        } catch (error) {
            console.error('Error during GET request:', error);
            setFirmUrl('');
        }
    };

    return (
        <>
            {firmUrl !== undefined &&
                <img
                    src={`${imgUrl}/${firmUrl}`}
                    alt="error"
                    style={{ margin: '0 2%', width: '95%' }}

                />}
        </>
    );
}

export default React.memo(FirmHeaderImg);
